import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64872 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5C18.3513 0.5 23.5 5.64872 23.5 12Z",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.2428 7.75737L7.75752 16.2427",
			stroke: "currentColor",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.2428 16.2426L7.75752 7.75735",
			stroke: "currentColor",
			strokeLinecap: "round"
		})
	]
});
export default SvgClose;
